<template>
	<vx-card class="author-upload">
		<div class="frsTitleStageAuthor" v-if="isUploadDisabled">
			<b>{{ $t('waitForConfirmationJobAcceptance') }} {{ $t('stageNumberInOrder') }} № {{ numStage }}.</b>
		</div>
		<div class="frsTitleStageAuthor" v-if="!isUploadDisabled">
			<b>{{ $t('uploadCompletedStage') }} {{ $t('stageNumberInOrder') }} № {{ numStage }}.</b>
		</div>
		<div>
			<vs-upload
				v-if="!isUploadDisabled"
				:key="'filesToUpload' + filesToUploadCounter"
				:show-upload-button="false"
				:text="$t('loadFile')"
				:disabled="isUploadDisabled"
				accept=".jpg,.jpeg,.png,.xls,.xlsx,.docx,.odt,.rtf,pptx,.pdf,.txt,.csv,.zip,.page,.sav,.MP4,.MOV,.MPG,.AVI,.M4V,.3GP,.3GGP,.MX20,.MX18,.MX12,.r"
				@change="addPhoto"
				@on-delete="deletePhoto"
			/>
			<div
				v-if="filesToUpload.length !== 0"
				:class="{ 'disabled-confirm-button': isConfirmDisabled }"
				class="mt-5"
			>
				<span
					class="status status-ok cursor-pointer mt-3"
					@click="uploadPhotos"
				>{{ $t('confirmUploading') }}</span>
			</div>
			<div v-if="files.length !== 0" class="mt-5 mb-3">
				<b>{{ $tc('attachedFiles', files.length) }}:</b>
			</div>
			<div class="vx-row">
				<div
					v-for="(file, index) in files"
					:key="index"
					class="vx-col mb-3"
				>
					<FileNameView
						:url="file.url"
						:orderId="orderId"
						:numFile="index"
						@fileDeleted="updateModel"
					/>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import FileNameView from "@/views/Tickets/FileNameView";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "AuthorUpload",
	mixins: [databaseManager, notifier],
	props: {
		orderId: { required: true, type: Number },
		orderStatus: { required: true, type: String },
		stage: { default: () => [] },
		numStage: {default: 0},
	},
	components: {
		FileNameView
	},
	data() {
		return {
			filesToUpload: [],
			filesToUploadCounter: 0,
			isConfirmDisabled: false
		}
	},
	computed: {
		files() {
			if(!this.stage || !this.stage.files) return [];
			return this.stage.files;
		},
		isUploadDisabled () {
			return this.orderStatus !== "waiting_approve"
				&& this.orderStatus !== "in_progress"
		}
	},
	methods: {
		async updateModel(callback) {
			await this.$emit('updateModel', callback)
		},
		addPhoto(path, files) {
			this.filesToUpload.push(files[files.length - 1]);
		},
		deletePhoto(file) {
			const index = this.filesToUpload.findIndex(item => item === file);
			if(index !== -1) {
				this.filesToUpload.splice(index, 1);
			}
		},
		refreshInput() {
			this.filesToUpload = [];
			this.filesToUploadCounter++;
		},
		async uploadCallback() {
			try {
				if(this.isUploadDisabled) {
					this.refreshInput();
					this.notifyError(this.$t('isConfirmingStage'));
					return;
				}
				if(!(this.stage && this.$store.state.auth.role === 'author')) return;

				const urls = await this.dbUploadMany(this.filesToUpload);
				const files = urls.map(item => item.url);

				const attachUrl = `/author/order/attach-files/${this.$route.params.id}`;
				const attachOptions = `?milestone_id=${this.stage.id}`;
				const request = `${attachUrl}${attachOptions}`;
				const res = (await this.$http.post(request, { files } )).data.data;

				res.files.forEach(item => this.files.push(item))
			} catch (e) {
				this.notifyError(e.message);
			}

			this.refreshInput();

			this.notifySuccess(
				`${this.$t('thanksWeReceivedYourRequest')}.<br>` +
				`${this.$t('managerWillConfirmItSoon')}. ` +
				`${this.$t('pleaseWait')}`
			);

			this.isConfirmDisabled = false;
		},
		async uploadPhotos() {
			if(this.isConfirmDisabled) return;

			this.isConfirmDisabled = true;

			await this.updateModel(() => this.uploadCallback());
		},
	}
}
</script>

<style lang="scss">
	.frsTitleStageAuthor {
		margin-bottom: 10px;
	}
.author-upload {
	.con-img-upload {
		overflow: auto !important;
	}

	.disabled-confirm-button {
		.status {
			background-color: #d5d5d5;
			cursor: not-allowed !important;
		}
	}
}
</style>
